import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { TRANSLATIONS, DEFAULT_LANG, SUPPORTED_LANGS } from "./translations";

const LANG_KEY = "tirami_lang";
const LanguageContext = createContext({
  lang: DEFAULT_LANG,
  setLang: () => {},
  t: (k) => k,
});

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    const stored = typeof window !== "undefined" && localStorage.getItem(LANG_KEY);
    return SUPPORTED_LANGS.includes(stored) ? stored : DEFAULT_LANG;
  });

  useEffect(() => {
    if (typeof window !== "undefined") {
      localStorage.setItem(LANG_KEY, lang);
      document.documentElement.setAttribute("lang", lang);
    }
  }, [lang]);

  const value = useMemo(() => {
    const dict = TRANSLATIONS[lang] || TRANSLATIONS[DEFAULT_LANG];
    const t = (key) => dict[key] ?? TRANSLATIONS[DEFAULT_LANG][key] ?? key;
    return { lang, setLang: setLangState, t };
  }, [lang]);

  return (
    <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>
  );
}

export function useT() {
  return useContext(LanguageContext);
}
